export class BackendClientBase {

    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        options.credentials = "include";
        return Promise.resolve(options);
    }

}